import { useAuth0 } from "@auth0/auth0-react"
import { useSetAtom } from "jotai"
import { userAtom } from "../atoms/user"
import { partnerAtom } from "../atoms/partner"
import { trackEvent } from "../monitoring/tracking"
import { useEffect } from "react"
import { localStorageKeys, setLocalStorageValueByKey } from "./LocalStorageHooks"

/* Set user data from Auth0 */
export const useUpdateUser = () => {
	const { user, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
	const setUser = useSetAtom(userAtom);
	const setPartner = useSetAtom(partnerAtom);

	useEffect(() => {
		const updateUserData = async () => {
			if (isAuthenticated && !isLoading && user) {
				// Auth0 user data structure
				const given_name = user.given_name || user.name?.split(' ')[0] || "Customer";
				const family_name = user.family_name || user.name?.split(' ').slice(1).join(' ') || "";
				const email = user.email || "";

				// Get permissions from access token
				let isAdmin = false;
				try {
					const accessToken = await getAccessTokenSilently();
					// Decode JWT to extract permissions (JWT format: header.payload.signature)
					const payload = JSON.parse(atob(accessToken.split('.')[1]));
					const permissions = payload.permissions || [];
					isAdmin = permissions.includes('api.majortom');
				} catch (error) {
					console.error('Error getting permissions from access token:', error);
				}

				// Security: Clear PARTNER_CODE from local storage and atom if user is not admin
				// This prevents non-admin users from retaining partner codes after permission changes
				if (!isAdmin) {
					setLocalStorageValueByKey(localStorageKeys.PARTNER_CODE, "");
					setPartner("");
				}

				// Update user atom with isAdminCheckComplete flag
				setUser({ given_name, family_name, email, isAdmin, isAdminCheckComplete: true });

				// Track authentication event
				if (email) {
					trackEvent("User authentication", {
						name: `${given_name} ${family_name}`.trim(),
						email: `${email}`,
						provider: 'auth0'
					});
				}
			}
		};

		updateUserData();
	}, [user, isAuthenticated, isLoading, setUser, getAccessTokenSilently, setPartner]);
};